<template>
  <div class="divided"></div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.divided {
  height: 12px;
  background: #f7f8fa;
}
</style>
